var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "navigation/arrowright") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Template",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bootstrap-Extra-large:-Desktops-\\u2014-12-Columns",
    transform: "translate(-1351.000000, -1193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/arrowright",
    transform: "translate(1351.000000, 1193.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L24,0 L24,24 L0,24 L0,0 Z",
    id: "Transparent-BG",
    strokeOpacity: 0.01,
    stroke: "#FFFFFF",
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "14 6.22319774 14 3.55019746 23.315033 11.8098149 14 20.4368474 14 17.710871 19.08656 13 1.5 13 1.5 11 19.387183 11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArrowright);
export default __webpack_public_path__ + "static/media/icons-arrowright.da70675cf13938de247e131fae34c687.svg";
export { ForwardRef as ReactComponent };